<template>
    <span class="text-danger">
        <i
            class="fa fa-ban fa-lg icon-button"
            title="Reprovar"
            @click.stop="confirmarReprovacao()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        solicitacaoReabertura: {
            type: Object,
            default: () => {}
        },

        solicitacoesReaberturasServicos: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarReprovacao() {
            this.$swal({
                title: 'Solicitação de Reabertura Reprovada',
                html: `Confirma a REPROVAÇÃO da solicitação de reabertura da entrega ${this.solicitacaoReabertura.entrega.descritivo} da contratação ${this.solicitacaoReabertura.entrega.contratacao.codContratacao}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa da reprovação',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa da reprovação é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovar(result.value)
                }
            })
        },

        reprovar(justificativa) {
            this.$store.dispatch('addRequest')
            let solicitacaoReaberturaReprovadaDto = {
                solicitacaoReaberturaId: this.solicitacaoReabertura
                    .solicitacaoReaberturaId,
                detalheReprovacao: justificativa
            }
            this.solicitacoesReaberturasServicos
                .reprovar(solicitacaoReaberturaReprovadaDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Solicitação de reabertura reprovada com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizar-listagem')
                        } else {
                            this.$toast.error(
                                'Falha ao atualizar a solicitação de reabertura',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
